module.exports = __webpack_public_path__ + "static/media/anna.2c845f24.png";